<ng-container>
  <app-modal
      [open]="showModalConfirmRemove"
      title="{{ 'order-approve.remove-modal-title-info' | translate }}"
      [id]="orderId"
      (crossClick)="crossClick()">
    <ng-container ngProjectAs="[slot][body]">
      @if (!deleteLastItemAndDeclineOrderFlag) {
        <h5 class="modal-h5-title">
          {{ 'order-approve.remove-modal-content' | translate:{name: clickedItemDataName} }} </h5>
      }
      @if (deleteLastItemAndDeclineOrderFlag) {
        <h5 class="modal-h5-title">
          @if (isApprover$ | async) {
            {{ 'order-approve.last-item-decline-order-modal-content' | translate:{name: clickedItemDataName} }}
          } @else {
            {{ 'orders-page.last-item-decline-order-modal-content' | translate:{name: clickedItemDataName} }}
          }
        </h5>
      }
    </ng-container>
    <ng-container ngProjectAs="[slot][footer]">
      <button type="button" (click)="crossClick()" class="button button" data-dismiss="modal-dialog"
              [disabled]="setButtonDisabledAttribute" [attr.data-test]="'button-keepItem'">
        {{ 'order-approve.keep-item' | translate}}
      </button>
      @if (!deleteLastItemAndDeclineOrderFlag) {
        <button type="button" (click)="clickRemoveItemFromCart()"
                class="button button--primary" data-dismiss="modal-dialog" [disabled]="setButtonDisabledAttribute"
                [attr.data-test]="'button-removeItem'">
          {{ 'order-approve.remove-item' | translate}}
        </button>
      }
      @if (deleteLastItemAndDeclineOrderFlag) {
        <button type="button" (click)="clickDeclineOrder()"
                class="button button--primary"
                data-dismiss="modal-dialog"
                [disabled]="setButtonDisabledAttribute"
                [attr.data-test]="'button-removeItem'">
        @if (isApprover$ | async) {
          {{ 'order-approve.decline-order-button' | translate }}
        } @else {
          {{ 'orders-page.decline-order-buyer' | translate }}
        }
      </button>
      }
    </ng-container>
  </app-modal>
</ng-container>
